// Web shim for TurboModuleRegistry
// 确保在 Web 环境中可用
declare const window: any;

const TurboModuleRegistry: any = {
  get: (moduleName: string) => {
    // 为 DeviceInfo 提供特殊的 shim
    if (moduleName === 'DeviceInfo') {
      return {
        getConstants: () => ({
          Dimensions: {
            windowPhysicalPixels: { 
              width: typeof window !== 'undefined' ? window.innerWidth : 375, 
              height: typeof window !== 'undefined' ? window.innerHeight : 667, 
              scale: 1, 
              fontScale: 1 
            },
            screenPhysicalPixels: { 
              width: typeof window !== 'undefined' ? window.screen?.width || 375 : 375, 
              height: typeof window !== 'undefined' ? window.screen?.height || 667 : 667, 
              scale: 1, 
              fontScale: 1 
            },
          },
          isTesting: false,
        }),
      };
    }
    // 为 NativeHapticFeedback 提供 shim
    if (moduleName === 'NativeHapticFeedback') {
      return {
        trigger: () => {}, // 空操作
      };
    }
    return null;
  },
  getEnforcing: (moduleName: string) => {
    // getEnforcing 应该返回与 get 相同的结果，但不允许为 null
    const module = TurboModuleRegistry.get(moduleName);
    if (module === null) {
      // 为常见模块提供默认 shim
      if (moduleName === 'DeviceInfo') {
        return {
          getConstants: () => ({
            Dimensions: {
              windowPhysicalPixels: { 
                width: typeof window !== 'undefined' ? window.innerWidth : 375, 
                height: typeof window !== 'undefined' ? window.innerHeight : 667, 
                scale: 1, 
                fontScale: 1 
              },
              screenPhysicalPixels: { 
                width: typeof window !== 'undefined' ? window.screen?.width || 375 : 375, 
                height: typeof window !== 'undefined' ? window.screen?.height || 667 : 667, 
                scale: 1, 
                fontScale: 1 
              },
            },
            isTesting: false,
          }),
        };
      }
      if (moduleName === 'NativeHapticFeedback') {
        return {
          trigger: () => {}, // 空操作
        };
      }
      return {};
    }
    return module || {};
  },
};

// 同时提供命名导出和默认导出
export const getEnforcing = TurboModuleRegistry.getEnforcing;
export const get = TurboModuleRegistry.get;
export { TurboModuleRegistry };
export default TurboModuleRegistry;

